module.exports = __webpack_public_path__ + "static/media/ixordocs-hero.6097df18.png";